import { render, staticRenderFns } from "./CmgNutritionCalculatorEntreeSelector.vue?vue&type=template&id=4b0e1a24&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-entree-selector.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-entree-selector.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorEntreeSelector.vue?vue&type=style&index=0&id=4b0e1a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e1a24",
  null
  
)

export default component.exports